import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import './PublicLayout.css';

const PublicLayout = () => {
  return (
    <div className="public-layout">
      <Header isPublic={true} />
      <main className="public-main">
        <Outlet />
      </main>
      <footer className="public-footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Gauss Control. Todos los derechos reservados.</p>
          <p>Sistema de Denuncias Anónimas - Modelo de Prevención de Delitos</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
